// hooks/useCompany.js
import useTranslation from './useTranslation';

const useCompany = () => {
  const { t } = useTranslation();

  // Return object with string properties
  const company = {
    name: t('common.company_name'),
    tagline: t('common.company_tagline'),
    fullName: t('common.company_full_name'),
    abbreviated: t('common.company_abbreviated'),
  };

  return {
    company,
  };
};

export default useCompany;
